import React, { useEffect, useRef, useCallback } from "react";
import {
  createTheme,
  StyledEngineProvider,
  ThemeProvider,
} from "@mui/material/styles";
import "core-js/stable";
import { useSelector, useDispatch } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import "regenerator-runtime/runtime";
import "./assets/scss/index.scss";
import RoutesMain from "./routes/index";
import { getSoundSetting } from "./store/features/getSoundSetting";
import { getAgentStatus } from "./store/features/getAgentStatusTeam";
import { setFavicon, isLiveRoomOpen, getRoomListPreviewFields } from "./utils/index";
import {
  resolveRoomSoundPlay,
  isRoomAssignedToAgent,
} from "./utils/roomNotificationSound";
import {
  createNotificationAudio,
  playNotificationAudio,
  unlockNotificationAudio,
} from "./utils/notificationAudio";
import {
  isJoinNoticeMessage,
  registerRoomWelcomePreviewFromRoom,
  shouldSuppressMessageNotification,
} from "./utils/messageNotification";
import {
  hasOutstandingInvite,
  isInvitedRoom,
  rememberInvitedRoomFromRoom,
} from "./utils/invitedChats";
import { toast } from "react-toastify";
import { resetUser } from "./store/features/loginUser";
import { hasMasterSession } from "./utils/authSession";
import { registerServiceWorker, subscribeUser, unsubscribeUser } from "./utils/notification";
import { showBrowserNotification } from "./utils/notificationCopy";
import { setKbGroupId } from "./utils/kbGroupId";
import { clearSessionScopedState } from "./utils/clearSessionScopedState";
import { getLiveChatBasePath } from "./utils/liveChatPath";

import { ReactComponent as trustchatLogo } from "./assets/images/trustchatlogo.svg";
import { useSocket } from "./SocketContext";
import { emitAgentSetup } from "./api/createAppSocket";
import { forceAuthExpiry } from "./api/authHttp";
import { resetAgentUser } from "./store/features/loginUserTenant";
import { getUserSessions } from "./store/features/getUserSessions";
import {
  NOTIFICATION_SOCKET_EVENTS,
  fetchNotificationUnreadCount,
} from "./store/features/notifications";
import { TICKETS_HOME_PATH, LIVE_CHAT_HOME_PATH } from "./config/featureFlags";

function App() {
  console.log("We are Updated");
  const theme = createTheme({});
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.loginToken);
  console.log("userData", userData);
  console.log("Best REMOVE CUSTOM DOMAIN");
  const {
    sessions = [],
    loading,
    error,
  } = useSelector((state) => state.getUserSessions);
  console.log("daraa", sessions);
  const socket = useSocket();
  const isSignedIn = hasMasterSession(userData);
  const email = useSelector((state) => state.loginToken?.response?.user?.email); // adjust based on your store
  const apiKey = process.env.REACT_APP_VAPID_PUBLIC_KEY;
  console.log("API KWTTTTTTTTTTT*******8", apiKey);
  console.log("lojo", email);
  const soundOnRef = useRef(false);
  const notificationSoundRef = useRef(null);
  const inactivityTimer = useRef(null);
  const tabDisconnectTimer = useRef(null);
  const lastPlayedRoomRef = useRef({ id: null, ts: 0 });

 
  useEffect(() => {
    const audio = createNotificationAudio();
    notificationSoundRef.current = audio;

    const unlock = () => {
      unlockNotificationAudio(notificationSoundRef.current || audio);
      window.removeEventListener("click", unlock);
      window.removeEventListener("keydown", unlock);
      window.removeEventListener("touchstart", unlock);
    };
    window.addEventListener("click", unlock, { once: true });
    window.addEventListener("keydown", unlock, { once: true });
    window.addEventListener("touchstart", unlock, { once: true });

    // After long idle Chrome can leave the media element in a bad cache state;
    // recreate on return so the next room sound does not hit
    // ERR_CACHE_OPERATION_NOT_SUPPORTED.
    const onVisible = () => {
      if (document.visibilityState !== "visible") return;
      const prev = notificationSoundRef.current;
      try {
        prev?.pause();
      } catch (_) {}
      notificationSoundRef.current = createNotificationAudio();
    };
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      try {
        audio.pause();
      } catch (_) {}
      window.removeEventListener("click", unlock);
      window.removeEventListener("keydown", unlock);
      window.removeEventListener("touchstart", unlock);
      document.removeEventListener("visibilitychange", onVisible);
      notificationSoundRef.current = null;
    };
  }, []);


  const playNotificationSound = useCallback(() => {
    if (!soundOnRef.current) return;
    playNotificationAudio(notificationSoundRef);
  }, []);


  const playRoomSoundOnce = useCallback(
    (roomId) => {
      const now = Date.now();
      const { play, nextLastPlayed } = resolveRoomSoundPlay(
        lastPlayedRoomRef.current,
        roomId,
        now,
      );
      if (!play) return;
      lastPlayedRoomRef.current = nextLastPlayed;
      playNotificationSound();
    },
    [playNotificationSound],
  );
  const notificationUnreadCount = useSelector(
    (state) => state.notifications?.unreadCount ?? 0,
  );
  console.log("📢 Frontend VAPID key:", apiKey);
  useEffect(() => {
    if (isSignedIn) dispatch(getUserSessions());
  }, [dispatch, isSignedIn]);

  useEffect(() => {
    const uid = userData?.response?.user?._id;
    const bid = userData?.response?.user?.business_id;
    if (!uid || !bid) return;
    dispatch(fetchNotificationUnreadCount());
  }, [dispatch, userData?.response?.user?._id, userData?.response?.user?.business_id]);

  useEffect(() => {
    if (!socket || !userData?.response?.user?.email) return;

    const currentEmail = userData.response.user.email;

    const handleForceLogout = async ({ email }) => {
      console.log("force-logout received:", email, "expected:", currentEmail);

      if (
        email &&
        email.toLowerCase().trim() === currentEmail.toLowerCase().trim()
      ) {
        await unsubscribeUser({ clearAll: true });
        clearSessionScopedState();
        localStorage.clear();
        dispatch(resetUser());
        dispatch(resetAgentUser());
        window.location.href = "/login";
      }
    };

    socket.on("reset-logout", handleForceLogout);
    return () => socket.off("reset-logout", handleForceLogout);
  }, [socket, userData?.response?.user?.email, dispatch]);
  useEffect(() => {
    if (!socket) return;

    const onCheckSingleLogout = async (agentId) => {
      const userId = userData?.response?.user?._id;
      if (agentId && userId && agentId === userId) {
        await unsubscribeUser({ clearAll: false });
        localStorage.removeItem("sessionId");

        dispatch(resetUser());
        dispatch(resetAgentUser());
        window.location.href = "/login";
      }
    };

    socket.on("check-logout", onCheckSingleLogout);
    return () => socket.off("check-logout", onCheckSingleLogout);
  }, [socket, userData?.response?.user?._id, userData?.response?.user?.email, dispatch]);
  useEffect(() => {
    async function initPush() {
      // Only subscribe while logged in — never re-register after logout clears the session.
      if (!email || !isSignedIn || !apiKey) return;

      try {
        const registration = await registerServiceWorker();
        if (registration) {
          await subscribeUser(registration, apiKey);
        }
      } catch (err) {
        // Edge can fail push registration when the push service is unreachable.
        // Never block login / hard refresh on optional web push.
        console.warn("Push init skipped:", err?.message || err);
      }
    }
    initPush();
  }, [apiKey, isSignedIn, email]);

  useEffect(() => {
    if (userData?.response?.sessionId) {
      localStorage.setItem("sessionId", userData.response.sessionId);
    }
  }, []);
  useEffect(() => {
    if (
      !socket ||
      !userData?.response?.sessionId ||
      !userData?.response?.user?._id
    )
      return;

    const currentSessionId = userData.response.sessionId;

    // Re-join on every connect/reconnect so force-logout still reaches this device.
    const joinSessionRoom = () => {
      socket.emit("join-session", { sessionId: currentSessionId });
    };

    const handleForceLogout = async ({ sessionId }) => {
      console.log("Force logout received for session:", sessionId);
      if (sessionId !== currentSessionId) return;
      try {
        await unsubscribeUser({ clearAll: false });
      } catch (_) {
        /* ignore push cleanup failures during forced logout */
      }
      forceAuthExpiry();
    };

    joinSessionRoom();
    socket.on("connect", joinSessionRoom);
    socket.on("force-logout", handleForceLogout);

    return () => {
      socket.off("connect", joinSessionRoom);
      socket.off("force-logout", handleForceLogout);
    };
  }, [socket, userData?.response?.sessionId, userData?.response?.user?._id]);

  useEffect(() => {
    if (!isSignedIn) return undefined;

    const verifySessions = async () => {
      if (typeof navigator !== "undefined" && !navigator.onLine) {
        console.warn("Session verification skipped: browser is offline.");
        return;
      }
      try {
        const result = await dispatch(getUserSessions());
        if (getUserSessions.rejected.match(result)) {
          const status =
            result.payload?.status ||
            result.payload?.statusCode ||
            result.payload?.response?.status;
          const message = String(
            result.payload?.message || result.payload || "",
          ).toLowerCase();
          // 401 / expired session → force logout. Network errors still skip.
          if (
            status === 401 ||
            message.includes("unauthorized") ||
            message.includes("session has expired") ||
            message.includes("session expired")
          ) {
            try {
              await unsubscribeUser({ clearAll: false });
            } catch (_) {
              /* ignore */
            }
            forceAuthExpiry();
            return;
          }
          console.warn(
            "Session verification skipped (request failed, e.g. offline):",
            result.payload,
          );
          return;
        }

        const sessionsPayload = result?.payload;
        const sessions = Array.isArray(sessionsPayload?.sessions)
          ? sessionsPayload.sessions
          : Array.isArray(sessionsPayload)
            ? sessionsPayload
            : [];

        const currentSessionId = userData?.response?.sessionId;
        const sessionGone =
          !Array.isArray(sessions) ||
          sessions.length === 0 ||
          (currentSessionId &&
            !sessions.some((s) => s.sessionId === currentSessionId));

        if (sessionGone) {
          try {
            await unsubscribeUser({ clearAll: false });
          } catch (_) {
            /* ignore */
          }
          forceAuthExpiry();
        }
      } catch (e) {
        console.error("Error verifying sessions:", e);
      }
    };

    verifySessions();

    // Remote logout may not arrive over the socket; re-check when the tab is focused.
    const onVisible = () => {
      if (document.visibilityState === "visible") verifySessions();
    };
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", onVisible);
    return () => {
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", onVisible);
    };
  }, [dispatch, isSignedIn, userData?.response?.sessionId]);

  useEffect(() => {
    getSound();
  }, [userData?.response?.user?._id]);
  console.log("Connn=>>>> 14/5/23");

  useEffect(() => {
    const handleStorage = async (event) => {
      if (event.key === "logout") {
        // Other tab already cleared backend on logout-all; drop this browser's push sub.
        await unsubscribeUser({ clearAll: false });
        clearSessionScopedState();
        localStorage.clear();
        window.location.href = "/login";
      }
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, [userData?.response?.user?.email]);

  const getSuspendStatus = async () => {
    try {
      const response = await dispatch(
        getAgentStatus({
          id: userData?.response?.user?._id,
        }),
      );

      if (getAgentStatus.rejected.match(response)) {
        console.warn(
          "Agent status check skipped (request failed, e.g. offline):",
          response.payload,
        );
        return;
      }

      if (response?.payload?.status === 200) {
        const { is_active, is_offline } = response.payload;
        console.log("response payload", response.payload);
        if (!is_active || is_offline) {
          clearSessionScopedState();
          localStorage.clear();
          window.location.href = "/login";
        }
      }
    } catch (error) {
      console.error("Error fetching agent status:", error);
    }
  };
  console.log("sookha");
  useEffect(() => {
    if (userData?.response?.user?._id) {
      getSuspendStatus();
    }
  }, [userData?.response?.user?._id]);

  const getSound = async () => {
    try {
      const response = await dispatch(
        getSoundSetting({
          id: userData?.response?.user?._id,
        }),
      );

      if (response?.payload?.status === 200) {
        soundOnRef.current =
          response.payload.settings?.enableNotifications ?? false;
      }
    } catch (error) {
      console.error("Error fetching sound settings:", error);
    }
  };


  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;

    const onSWMessage = (event) => {
      const data = event?.data;
      if (!data || data.type !== "PUSH_NOTIFICATION") return;
      console.log("Push notification received from SW:", data.payload);
      // The socket stays alive in a hidden tab and already sounded this message.
      // Push is the fallback for when it cannot, and it can arrive well after any
      // dedup window, so defer on the connection rather than on timing.
      if (socket?.connected) return;
      playRoomSoundOnce(data?.payload?.roomId);
    };

    navigator.serviceWorker.addEventListener("message", onSWMessage);
    return () => {
      navigator.serviceWorker.removeEventListener("message", onSWMessage);
    };
  }, [playRoomSoundOnce, socket]);

  useEffect(() => {
    const onSettingsUpdated = (event) => {
      try {
        const { enableNotifications } = event?.detail || {};
        if (typeof enableNotifications !== "undefined") {
          soundOnRef.current = !!enableNotifications;
          console.log("Sound setting synced in App.js:", soundOnRef.current);
        }
      } catch (e) {
        console.log("Error in onSettingsUpdated", e);
      }
    };
    window.addEventListener("sound-settings-updated", onSettingsUpdated);
    return () => {
      window.removeEventListener("sound-settings-updated", onSettingsUpdated);
    };
  }, []);

  useEffect(() => {
    if (!socket) {
      return;
    }

    const emitSetup = () => {
      if (userData?.response?.user?._id) {
        emitAgentSetup(socket);
      }
    };

    const onAppConnect = () => {
      console.log("Socket connected (App.js)");
      emitSetup();
    };

    const onAppConnectedAck = () => {
      console.log("Server acknowledged setup");
    };

    const onAppDisconnect = (reason) => {
      console.warn("Socket disconnected:", reason);
    };

    const onAppReconnect = (attempt) => {
      console.log("Reconnected after", attempt, "attempts");
      emitSetup();
      dispatch(fetchNotificationUnreadCount());
    };

    const onReconnectAttempt = (attempt) => {
      console.log("Reconnect attempt:", attempt);
    };

    socket.on("connect", onAppConnect);
    socket.on("connected", onAppConnectedAck);
    socket.on("disconnect", onAppDisconnect);
    socket.on("reconnect", onAppReconnect);
    socket.io.on("reconnect_attempt", onReconnectAttempt);

    const navigateFromInAppNotification = (n) => {
      if (!n) return;
      const { referenceModel, referenceId, metadata } = n;
      const meta = metadata || {};
      const notifGroupId = meta.groupId || meta.group_id || null;
      if (notifGroupId) {
        setKbGroupId(notifGroupId);
      }
      if (referenceModel === "Ticket" || referenceModel === "TicketMessage") {
        const ticketId =
          referenceModel === "TicketMessage"
            ? meta.ticketId ?? referenceId
            : referenceId;
        if (ticketId) {
          window.location.href = `${TICKETS_HOME_PATH}?ticketId=${ticketId}`;
        }
      } else if (referenceModel === "Room" || referenceModel === "Message") {
        window.location.href = `${LIVE_CHAT_HOME_PATH}?roomId=${meta.roomId ?? referenceId}`;
      } else if (n.type === "kb_article_pending_review") {
        const articleId = meta.articleId ?? referenceId;
        if (articleId) {
          const params = new URLSearchParams({ articleId });
          if (notifGroupId) params.set("group_id", notifGroupId);
          window.location.href = `/kb/review-queue?${params.toString()}`;
        }
      } else if (
        referenceModel === "KBFeedbackQueue" ||
        n.type === "kb_feedback_received" ||
        n.type === "kb_feedback_assigned"
      ) {
        const feedbackId = referenceId || meta.feedbackId;
        if (feedbackId) {
          const params = new URLSearchParams({ feedbackId });
          if (notifGroupId) params.set("group_id", notifGroupId);
          window.location.href = `/kb/feedback-queue?${params.toString()}`;
        }
      } else {
        const articleId =
          meta.articleId ??
          (referenceModel === "KBArticle" ? referenceId : null);
        if (articleId) {
          window.location.href = `/kb/article/${articleId}`;
        }
      }
    };

    const onNewInAppNotification = (notification) => {
      if(notification.referenceModel === "Room" || notification.referenceModel === "Message") return
      if (!notification?._id) return;
      playNotificationSound();
      if ("Notification" in window && Notification.permission === "granted") {
        try {
          const type = notification.type || notification.notificationType;
          const metadata = notification.metadata || {};
          console.log(type,metadata , "metadata and type")
          
          showBrowserNotification(type, metadata, {
            icon: "/favicon.ico",
            tag: String(notification._id),
            silent: true,
            onClick: (e) => {
              e.preventDefault();
              window.focus();
              navigateFromInAppNotification(notification);
            },
          });
        } catch (err) {
          console.error("In-app notification toast failed:", err);
        }
      }
    };

    NOTIFICATION_SOCKET_EVENTS.forEach((ev) =>
      socket.on(ev, onNewInAppNotification),
    );

    // socket.on("msg fetched", (newMessageReceived) => {
    //   console.log("New message received:", newMessageReceived);

    //   if (
    //     soundOnRef.current &&
    //     (newMessageReceived?.message?.assignedTo
    //       ? newMessageReceived?.message?.assignedTo
    //       : newMessageReceived?.message?.assignedAgentId) ===
    //       userData?.response?.user?._id
    //   ) {
    //     playNotificationSound();
    //   }
    // });
    const onMsgFetchedSoundOnly = (newMessageReceived) => {
      const msg = newMessageReceived?.message;

      const isReceiver =
        (msg?.assignedTo ? msg?.assignedTo : msg?.assignedAgentId) ===
        userData?.response?.user?._id;

      const isSender = msg?.senderId === userData?.response?.user?._id;

      if (soundOnRef.current && isReceiver && !isSender) {
        console.log("Playing notification sound for receiver only");
        playNotificationSound();
      }
    };

    socket.on("msg fetched", onMsgFetchedSoundOnly);

    const onCreateRoomApp = (newRoom) => {
      const currentUserId = userData?.response?.user?._id;
      if (!currentUserId || !newRoom) return;

      registerRoomWelcomePreviewFromRoom(newRoom);
      rememberInvitedRoomFromRoom(newRoom);

      if (isRoomAssignedToAgent(newRoom, currentUserId)) {
        playRoomSoundOnce(newRoom?._id || newRoom?.id);
      }
    };

    socket.on("create-room", onCreateRoomApp);

    const onCheckLogoutApp = async (agentId) => {
      if (agentId === userData?.response?.user?._id) {
        await unsubscribeUser({ clearAll: true });
        clearSessionScopedState();
        localStorage.clear();
        window.location.href = "/login";
      }
    };

    socket.on("check-logout", onCheckLogoutApp);

    const markActive = () => {
      console.log("Marking agent as active...");
      if (!socket?.connected) {
        console.log("Reconnecting socket...");
        socket.connect();
        setTimeout(() => {
          socket.emit("agent_active", {
            id: userData?.response?.user?._id,
          });
        }, 500);
      } else {
        socket.emit("agent_active", {
          id: userData?.response?.user?._id,
        });
      }
    };

    const resetTimer = () => {
      clearTimeout(inactivityTimer.current);
      inactivityTimer.current = setTimeout(() => {
        console.log("User inactive ======================>>>>");
      }, 9000);
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        // Tab switched/minimized → KEEP socket alive
        console.log(
          "Tab hidden (switched or minimized) — keeping agent active",
        );
      } else {
        // Tab is visible again
        console.log("Tab visible again");
        clearTimeout(tabDisconnectTimer.current);

        // Mark user active
        markActive();

      }
    };

    const handleBeforeUnload = () => {
      console.log("Tab closing — scheduling inactivity");
      tabDisconnectTimer.current = setTimeout(() => {
        if (socket?.connected) {
          socket.emit("agent_inactive", {
            userId: userData?.response?.user?._id,
          });
          socket.disconnect();
          console.log("🚪 Agent marked inactive after tab close");
        }
      }, 120000); // 2 minutes
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("click", resetTimer);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    markActive();
    resetTimer();

    return () => {
      clearTimeout(inactivityTimer.current);
      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("click", resetTimer);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("beforeunload", handleBeforeUnload);
      NOTIFICATION_SOCKET_EVENTS.forEach((ev) =>
        socket.off(ev, onNewInAppNotification),
      );
      socket.off("connect", onAppConnect);
      socket.off("connected", onAppConnectedAck);
      socket.off("disconnect", onAppDisconnect);
      socket.off("reconnect", onAppReconnect);
      socket.io.off("reconnect_attempt", onReconnectAttempt);
      socket.off("msg fetched", onMsgFetchedSoundOnly);
      socket.off("create-room", onCreateRoomApp);
      socket.off("check-logout", onCheckLogoutApp);
    };
  }, [
    socket,
    userData?.response?.user?._id,
    userData,
    dispatch,
    playNotificationSound,
    playRoomSoundOnce,
  ]);

  const showNotification = useCallback(
    (message) => {
      if (isLiveRoomOpen(message.roomId)) {
        return;
      }
      if (
        (!document.hasFocus() &&
          "Notification" in window &&
          Notification.permission === "granted") ||
        (message.isForRoomCreation &&
          "Notification" in window &&
          Notification.permission === "granted")
      ) {
        const notificationOptions = {
          body: message.content || "New message received",
          icon: trustchatLogo,
          badge: trustchatLogo,
          tag: message.createdAt,
          data: {
            roomId: message.roomId,
            messageId: message._id,
          },
        };
        const notification = new Notification(
          message.sender_name || "New Chat Message",
          notificationOptions,
        );

        notification.onclick = function (event) {
          event.preventDefault();
          window.focus();
          window.location.href = `${getLiveChatBasePath(window.location.pathname)}?roomId=${this.data.roomId}`;
          notification.close();
        };
      }
    },
    [userData?.response?.user?._id],
  );

  const handleRoomCreated = useCallback(
    (newRoom) => {
      console.log("Room created:", newRoom);
      const roomId = newRoom?._id || newRoom?.id;
      if (!roomId) return;

      const agentId = userData?.response?.user?._id;
      if (!isRoomAssignedToAgent(newRoom, agentId)) return;

      playRoomSoundOnce(roomId);

      registerRoomWelcomePreviewFromRoom(newRoom);
      rememberInvitedRoomFromRoom(newRoom);
      const preview = getRoomListPreviewFields(newRoom);
      showNotification({
        sender_name: newRoom.roomName || "New Assignment",
        content: preview.attachment
          ? "New attachment"
          : "New chat request received",
        isForRoomCreation: true,
        roomId,
      });
    },
    [userData?.response?.user?._id, playRoomSoundOnce, showNotification],
  );

  useEffect(() => {
    if (!socket) return;

    const onNewMessage = (newMessageReceived) => {
      const msg = newMessageReceived?.message;
      const roomId = msg?.roomId;
      const isAgent = msg?.isAgent;
      const assignedTo = msg?.assignedAgentId || msg?.assignedTo;
      const currentUserId = userData?.response?.user?._id;

      // The backend posts "<visitor> has joined the chat" as a message. It is kept
      // out of the thread, but for a chat this agent invited it is the awaited
      // answer, so surface it as a toast instead of dropping it.
      if (isJoinNoticeMessage(msg)) {
        if ((isInvitedRoom(roomId) || hasOutstandingInvite()) && !isLiveRoomOpen(roomId)) {
          toast.info(String(msg.content).trim(), {
            toastId: `join-notice-${roomId}`,
            onClick: () => {
              window.location.href = `${getLiveChatBasePath(
                window.location.pathname,
              )}?roomId=${roomId}`;
            },
          });
        }
        return;
      }

      if (shouldSuppressMessageNotification(msg)) {
        return;
      }

      const shouldNotify =
        !isAgent && assignedTo === currentUserId && !isLiveRoomOpen(roomId);

      // if (shouldNotify) {
      //   showNotification(msg);
      // }
    };

    socket.on("msg fetched", onNewMessage);
    // New assigned rooms arrive on this event; create-room alone is not enough.
    socket.on("room-created-notification", handleRoomCreated);

    return () => {
      socket.off("msg fetched", onNewMessage);
      socket.off("room-created-notification", handleRoomCreated);
    };
  }, [
    socket,
    userData?.response?.user?._id,
    userData,
    showNotification,
    playRoomSoundOnce,
    handleRoomCreated,
  ]);

  useEffect(() => {
    if (notificationUnreadCount > 0 && userData?.isSuccess) {
      document.title = `TrustChat (${notificationUnreadCount})`;
      setFavicon("/assets/images/reddot.svg");
    } else {
      document.title = "TrustChat";
      setFavicon("/favicon.ico");
    }
  }, [notificationUnreadCount, userData]);

  console.log("Informatiom", userData);
  useEffect(() => {
    if (userData?.response?.user?.is_offline) {
      console.log("User is offline or not authenticated. Logging out...");
      clearSessionScopedState();
      localStorage.clear();
      window.location.href = "/login";
    }
  }, [userData]);

  console.log("today date is 14 may");
  return (
    <ThemeProvider theme={theme}>
      <StyledEngineProvider injectFirst>
        {/* Connection status banners */}

        <Router>
          <RoutesMain />
        </Router>
      </StyledEngineProvider>
    </ThemeProvider>
  );
}

export default App;
